import React, { useEffect, useState } from "react";
import {
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Table,
  Tooltip,
  Transfer,
} from "antd";
import "./OfferingGroupSelectGroup.less";
import { uniqueId } from "lodash";
import { IOfferListProps } from "../../../../components/OfferList/utils/useOfferList";
import {
  OfferingGroupDataTypeTransfer,
  TableDataOfferingGroupSelectGroup,
  TableDataOfferingGroupSelectGroupParams,
} from "./OfferingGroupSelectGroupTypes";
import { displayFormat, toHttpFormatStartOfDay } from "../../../../lib/utils";
import { useAppDispatch, useAppSelector } from "../../../..";
import { searchOfferingGroupsAddOffer } from "../../store/slice/offeringGroupsSlice";
import versionsTableUtils from "../../../../lib/utils/versionsTableUtils";

const columnsWidths: TableDataOfferingGroupSelectGroup = {
  id: "50px",
  extName: "180px",
  name: "25%",
  fromDate: "110px",
  toDate: "110px",
};

const columnsParamsWidths: TableDataOfferingGroupSelectGroupParams = {
  inversion: "50px",
  name: "1px",
  minCardinality: "62%",
};

const columnsTemplateWidths: TableDataOfferingGroupSelectGroup = {
  id: "50px",
  extName: "180px",
  name: "25%",
  fromDate: "110px",
  toDate: "110px",
};

interface IProps {
  offerListProps: IOfferListProps;
  offerListPropsTemplate: IOfferListProps;
  activeParams: boolean;
  onChangeActiveParams: (newValue: boolean) => void;
  activeVisibleGroup: boolean;
  onChangeActiveVisibleGroup: (newValue: boolean) => void;
  targetKeys: string[];
  setTargetKeys: React.Dispatch<React.SetStateAction<string[]>>;
}

const OfferingGroupSelectGroup = ({
  offerListProps,
  offerListPropsTemplate,
  activeParams,
  onChangeActiveParams,
  activeVisibleGroup,
  onChangeActiveVisibleGroup,
  targetKeys,
  setTargetKeys,
}: IProps) => {
  const dispatch = useAppDispatch();

  const { offeringGroupsAddOffer, offeringGroupsTypesDic } = useAppSelector(
    (state) => state.offeringGroups
  );

  const [transferTableData, setTransferTableData] = useState<OfferingGroupDataTypeTransfer[]>([]);

  useEffect(() => {
    if (offeringGroupsAddOffer?.length > 0) {
      setTransferTableData(
        offeringGroupsAddOffer.map((el) => {
          const formatData = { ...el, key: `${el.id}`, name: el.name };

          return formatData;
        })
      );
    } else {
      setTransferTableData([]);
    }
  }, [offeringGroupsAddOffer]);

  const onSearchOfferingGroups = (onDate) => {
    const isSkip = offerListPropsTemplate.offerListSelectMode === "skip";

    dispatch(
      searchOfferingGroupsAddOffer({
        searchAllGroups: {
          onDate,
          page: 0,
          size: 9999,
          memberObjectId: isSkip ? undefined : offerListPropsTemplate.selectedOffer?.id,
          memberTypeAlias: isSkip ? undefined : "offering",
          extendedInfo: false,
        },
        searchInqludesGroups: {
          onDate,
          page: 0,
          size: 9999,
          memberObjectId: offerListProps.selectedOffer?.id,
          memberTypeAlias: "offering",
          extendedInfo: false,
        },
      })
    );
  };

  useEffect(() => {
    if (offerListProps.selectedOffer) {
      if (offerListProps.selectedOffer || offerListPropsTemplate.selectedOffer) {
        onSearchOfferingGroups(toHttpFormatStartOfDay(offerListProps.searchListValues.onDate));
      }
    }
  }, [offerListProps.selectedOffer, offerListPropsTemplate.selectedOffer]);

  const getOfferColumns = () => {
    return [
      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        width: columnsWidths.id,
        hidden: true,
      },
      {
        title: "Наименование",
        key: "extName",
        dataIndex: "extName",
        width: columnsWidths.extName,
      },
      {
        title: "Код",
        key: "name",
        dataIndex: "name",
        width: columnsWidths.name,
      },
      {
        title: "Период c",
        dataIndex: "fromDate",
        key: "fromDate",
        width: columnsWidths.fromDate,
        render: (fromDate) => {
          return (
            <Form.Item noStyle name="fromDate">
              <DatePicker
                format={displayFormat}
                onChange={(e) => onSearchOfferingGroups(toHttpFormatStartOfDay(e))}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "Период по",
        dataIndex: "toDate",
        key: "toDate",
        width: columnsWidths.toDate,
        render: (toDate) => {
          return (
            <Form.Item noStyle name="toDate">
              <DatePicker format={displayFormat} />
            </Form.Item>
          );
        },
      },
    ];
  };

  const getOfferParamsColumns = () => {
    return [
      {
        title: "Инверсия",
        key: "inversion",
        dataIndex: "inversion",
        width: columnsParamsWidths.inversion,
        render: () => {
          return (
            <Form.Item noStyle name="inversion">
              <Select
                allowClear
                style={{ width: 69, maxWidth: 69 }}
                options={[{ value: "true", label: "NOT" }]}
                disabled={!activeParams}
              />
            </Form.Item>
          );
        },
      },
      {
        title: "",
        key: "name",
        dataIndex: "name",
        width: columnsParamsWidths.name,
        render: (name) => null,
      },
      {
        title: (
          <Row justify="center">
            <Tooltip title="умолч | мин | макс">Количество</Tooltip>
          </Row>
        ),
        key: "minCardinality",
        dataIndex: "minCardinality",
        width: columnsParamsWidths.minCardinality,
        render: () => {
          return (
            <Row
              justify="center"
              style={{
                fontSize: 13,
                fontWeight: 700,
                alignItems: "center",
              }}
            >
              <Form.Item noStyle dependencies={["minCardinality", "maxCardinality"]}>
                {({ getFieldsValue, validateFields }) => {
                  const { minCardinality, maxCardinality } = getFieldsValue();

                  return (
                    <Form.Item
                      name="defaultCardinality"
                      className="form-item-required__hidden-error__mb0"
                      rules={[
                        {
                          required: activeParams,
                          message: "",
                        },
                        {
                          validator: (_, value) => {
                            let isSucces = true;

                            if (minCardinality) {
                              isSucces = Number(value) >= Number(minCardinality);
                            }
                            if (maxCardinality && isSucces) {
                              isSucces = Number(value) <= Number(maxCardinality);
                            }

                            return isSucces ? Promise.resolve() : Promise.reject();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{ width: 46, height: 32 }}
                        disabled={!activeParams}
                        onChange={() => validateFields()}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <span className="cardinality-value">|</span>
              <Form.Item noStyle dependencies={["defaultCardinality", "maxCardinality"]}>
                {({ getFieldsValue, validateFields }) => {
                  const { defaultCardinality, maxCardinality } = getFieldsValue();

                  return (
                    <Form.Item
                      name="minCardinality"
                      className="form-item-required__hidden-error__mb0"
                      rules={[
                        {
                          required: activeParams,
                          message: "",
                        },
                        {
                          validator: (_, value) => {
                            let isSucces = true;

                            if (defaultCardinality) {
                              isSucces = Number(value) <= Number(defaultCardinality);
                            }
                            if (maxCardinality && isSucces) {
                              isSucces = Number(value) <= Number(maxCardinality);
                            }
                            return isSucces ? Promise.resolve() : Promise.reject();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{ width: 46, height: 32 }}
                        disabled={!activeParams}
                        onChange={() => validateFields()}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <span className="cardinality-value"> | </span>
              <Form.Item
                noStyle
                dependencies={["defaultCardinality", "minCardinality", "maxCardinality"]}
              >
                {({ getFieldsValue, validateFields }) => {
                  const { defaultCardinality, minCardinality } = getFieldsValue();
                  return (
                    <Form.Item
                      name="maxCardinality"
                      className="form-item-required__hidden-error__mb0"
                      rules={[
                        {
                          required: activeParams,
                          message: "",
                        },
                        {
                          validator: (_, value) => {
                            let isSucces = true;

                            if (defaultCardinality) {
                              isSucces = Number(value) >= Number(defaultCardinality);
                            }
                            if (minCardinality && isSucces) {
                              isSucces = Number(value) >= Number(minCardinality);
                            }
                            return isSucces ? Promise.resolve() : Promise.reject();
                          },
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        style={{ width: 46, height: 32 }}
                        disabled={!activeParams}
                        onChange={() => validateFields()}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </Row>
          );
        },
      },
      {
        title: "",
        dataIndex: "fromDate",
        key: "fromDate",
        width: columnsParamsWidths.fromDate,
        render: (fromDate) => null,
      },
      {
        title: "",
        dataIndex: "toDate",
        key: "toDate",
        width: columnsParamsWidths.toDate,
        render: (fromDate) => null,
      },
    ];
  };

  const getOfferTemplateColumns = () => {
    return [
      {
        title: "ID",
        key: "id",
        dataIndex: "id",
        width: columnsTemplateWidths.id,
        hidden: true,
      },
      {
        title: "Наименование",
        key: "extName",
        dataIndex: "extName",
        width: columnsTemplateWidths.extName,
      },
      {
        title: "Код",
        key: "name",
        dataIndex: "name",
        width: columnsTemplateWidths.name,
      },
      {
        title: "",
        dataIndex: "fromDate",
        key: "fromDate",
        width: columnsWidths.fromDate,
        render: (fromDate) => null,
      },
      {
        title: "",
        dataIndex: "toDate",
        key: "toDate",
        width: columnsWidths.toDate,
        render: (fromDate) => null,
      },
    ];
  };

  const [offerColumns, setOfferColumns] = useState(getOfferColumns());

  const [offerParamsColumns, setOfferParamsColumns] = useState(getOfferParamsColumns());

  const [offerTemplateColumns, setOfferTemplateColumns] = useState(getOfferTemplateColumns());

  useEffect(() => {
    setOfferParamsColumns(getOfferParamsColumns());
  }, [activeParams]);

  const onChange = (nextTargetKeys: string[]) => {
    setTargetKeys(nextTargetKeys);
  };

  const [selectedFilters, setSelectedFilters] = useState({
    leftFilters: { name: "", groupingTypeId: undefined },
    rightFilters: { name: "", groupingTypeId: undefined },
  });

  const onChangeFilters = (
    filterPosition: "leftFilters" | "rightFilters",
    filterName: "name" | "groupingTypeId",
    newValue
  ) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [filterPosition]: {
        ...prev[filterPosition],
        [filterName]: newValue,
      },
    }));
  };

  const getTableTransfer = () => {
    return (
      <Transfer
        dataSource={transferTableData}
        titles={["Доступное", "Выбранное"]}
        targetKeys={targetKeys}
        disabled={!activeVisibleGroup}
        onChange={onChange}
        listStyle={{
          minWidth: 270,
          width: "100%",
          height: "60vh",
        }}
      >
        {({
          direction,
          filteredItems,
          onItemSelect,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled,
        }) => {
          const filterPosition = direction === "left" ? "leftFilters" : "rightFilters";

          const filteredItemsCustom = filteredItems.filter((el) => {
            let isSucces = true;
            if (selectedFilters[filterPosition].name) {
              isSucces = !!el.name
                ?.toLowerCase()
                .includes(selectedFilters[filterPosition].name?.toLowerCase());
            }
            if (selectedFilters[filterPosition].groupingTypeId && isSucces) {
              isSucces = el.groupingTypeId === selectedFilters[filterPosition].groupingTypeId;
            }
            return isSucces;
          });

          return (
            <div
              style={{
                cursor: listDisabled ? "no-drop" : undefined,
              }}
            >
              <div
                style={{
                  pointerEvents: listDisabled ? "none" : undefined,
                }}
              >
                <Row className="transfer-header">
                  <Row className="transfer-header-thead">
                    <Col className="ant-table-cell transfer-header-cell" span={15}>
                      <Input
                        value={selectedFilters[filterPosition].name}
                        onChange={(e) => onChangeFilters(filterPosition, "name", e.target.value)}
                        placeholder="Введите наименование"
                        allowClear
                      />
                    </Col>
                    <Col className="ant-table-cell transfer-header-cell" span={9}>
                      <Select
                        value={selectedFilters[filterPosition].groupingTypeId}
                        onChange={(e) => onChangeFilters(filterPosition, "groupingTypeId", e)}
                        style={{ width: "100%" }}
                        placeholder="Тип"
                        allowClear
                      >
                        {offeringGroupsTypesDic.length > 0 &&
                          offeringGroupsTypesDic.map((el) => {
                            return (
                              <Select.Option key={uniqueId()} value={el.id}>
                                {el.name}
                              </Select.Option>
                            );
                          })}
                      </Select>
                    </Col>
                  </Row>
                </Row>
                <Row className="transfer-body">
                  {filteredItemsCustom.map((el) => {
                    return (
                      <Row
                        style={{ cursor: "pointer" }}
                        className="transfer-body-thead"
                        onClick={() => {
                          if (listDisabled) return;
                          onItemSelect(
                            el.key as string,
                            !listSelectedKeys.includes(el.key as string)
                          );
                        }}
                      >
                        <Col
                          className="ant-table-cell transfer-body-cell"
                          span={2}
                          style={{ zIndex: 1 }}
                        >
                          <Checkbox
                            checked={listSelectedKeys.includes(String(el.key))}
                            onClick={() => {
                              if (listDisabled) return;
                              onItemSelect(
                                el.key as string,
                                !listSelectedKeys.includes(el.key as string)
                              );
                            }}
                            disabled={listDisabled}
                          />
                        </Col>
                        <Col className="ant-table-cell transfer-body-cell" span={14}>
                          {el.name}
                        </Col>
                        <Col className="ant-table-cell transfer-body-cell" span={8}>
                          {
                            versionsTableUtils.getDictionaryItemById(
                              offeringGroupsTypesDic,
                              el.groupingTypeId
                            )?.name
                          }
                        </Col>
                      </Row>
                    );
                  })}
                </Row>
              </div>
            </div>
          );
        }}
      </Transfer>
    );
  };

  return (
    <Row wrap={false} className="offering-group-select-group-container">
      <Col className="left-container" span={12}>
        <Row className="left-container__row">
          <Col span={24}>
            <h1>Предложение</h1>
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col span={24}>
            <Table
              columns={offerColumns}
              dataSource={offerListProps.selectedOffer ? [offerListProps.selectedOffer] : []}
              pagination={false}
              size="small"
            />
          </Col>
          <Col span={24} style={{ marginTop: 15 }}>
            <Checkbox
              disabled={offerListPropsTemplate.offerListSelectMode === "skip"}
              checked={activeParams}
              onChange={(e) => onChangeActiveParams(e.target.checked)}
            >
              Определить параметры
            </Checkbox>
          </Col>
          <Col span={24}>
            <Table columns={offerParamsColumns} pagination={false} dataSource={[{}]} size="small" />
          </Col>
        </Row>
        <Row className="left-container__row">
          <Col span={24}>
            <h1 style={{ marginTop: 15 }}>Шаблон</h1>
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col span={24}>
            <Table
              columns={offerTemplateColumns}
              dataSource={
                offerListPropsTemplate.selectedOffer ? [offerListPropsTemplate.selectedOffer] : []
              }
              pagination={false}
              size="small"
            />
          </Col>
        </Row>
      </Col>
      <Col className="right-container" span={12}>
        <Row>
          <Checkbox
            disabled={offerListPropsTemplate.offerListSelectMode === "skip" || activeParams}
            checked={activeVisibleGroup}
            onChange={(e) => onChangeActiveVisibleGroup(e.target.checked)}
          >
            Показать группы
          </Checkbox>
        </Row>
        <Row className="right-container__transfer-container">{getTableTransfer()}</Row>
      </Col>
    </Row>
  );
};

export default OfferingGroupSelectGroup;
